import { SmoothScroll } from "@/components/landing/SmoothScroll";
import { Seo } from "@/components/Seo";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { TrustMarquee } from "@/components/landing/TrustMarquee";
import { Stats } from "@/components/landing/Stats";
import { Showcase } from "@/components/landing/Showcase";
import { Manifesto } from "@/components/landing/Manifesto";
import { LeadForm } from "@/components/landing/LeadForm";
import { Footer } from "@/components/landing/Footer";

export const Landing = () => (
  <SmoothScroll>
    <Seo
      title="Interlocked Solutions | FireFlink Channel Partner in the UK"
      description="Interlocked Solutions is the official UK channel partner for FireFlink — bringing AI-powered, scriptless test automation to UK teams with local licensing, onboarding, implementation and managed QA support."
      path="/"
    />
    <div className="App relative">
      <Navbar />
      <main>
        <Hero />
        <TrustMarquee />
        <Stats />
        <Showcase />
        <Manifesto />
        <LeadForm />
      </main>
      <Footer />
    </div>
  </SmoothScroll>
);
